module.exports = __webpack_public_path__ + "img/fb10.02e23be5.jpg";